// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import clipboard from 'clipboard';
import './permission'
import './assets/styles/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import "element-ui/lib/theme-chalk/base.css"
import './assets/styles/mask.css';


import directive from './directive' //directive
import { checkPermi, checkRole } from "@/utils/permission";

import { download } from '@/utils/request'

import {
    matchFun
} from "@/utils/matching";
import {
    pubTeamMatchFun,
    pubTeamData
} from "@/utils/pubTeam";


Vue.config.productionTip = false

Vue.prototype.download = download
Vue.prototype.clipboard = clipboard;

Vue.prototype.msgSuccess = function (msg) {
    this.$message({
        showClose: true,
        message: msg,
        type: "success"
    });
}
Vue.prototype.msgError = function (msg) {
    this.$message({
        showClose: true,
        message: msg,
        type: "error"
    });
}
Vue.prototype.msgInfo = function (msg) {
    this.$message.info(msg);
}

Vue.prototype.ntfSuccess = function (msg) {
    this.$notify({
        title: '成功',
        message: msg,
        type: 'success',
        duration: 3000
    });
}
Vue.prototype.ntfWarning = function (msg) {
    this.$notify({
        title: '提示',
        message: msg,
        type: 'warning',
        duration: 3000
    });
}
Vue.prototype.ntfInfo = function (msg) {
    this.$notify.info({
        title: '消息',
        message: msg
    });
}
Vue.prototype.ntfError = function (msg) {
    this.$notify.error({
        title: '错误',
        message: msg
    });
}

Vue.prototype.matchThis = function (key) {
    //   console.log(key)
    return matchFun(key)
}

Vue.prototype.pubTeamThis = function (value) {
    //   console.log(value)
    return pubTeamMatchFun(value)
}
Vue.prototype.pubTeamList = function () {
    //   console.log(pubTeamData())
    return pubTeamData()

}


Vue.prototype.checkPermiFun = function (value) {
    //   console.log(value)
    // return checkPermi(value)
    return true
}

Vue.prototype.checkRoleFun = function (value) {
    //   console.log(value)
    // return checkRole(value)
    return true
}




// 全局组件挂载
// Vue.use(permission)

/* eslint-disable no-new */
Vue.use(ElementUI)
Vue.use(directive)
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js